import { Modal } from "react-bootstrap";
import { SkeletonBox } from "../../components/skeleton-box";
import { HBox } from "../../components/hbox";

export default function PaymentModalLoadingSkeleton() {
    const skeletonRows = Array.from({ length: 10 }, (_, i) => (
        <HBox justifyContent="between" className="margin-bottom-10" key={i}>
            <SkeletonBox
                style={{
                    width: "180px",
                    height: "30px",
                }}
            />
            <SkeletonBox
                style={{
                    width: "180px",
                    height: "30px",
                }}
            />
        </HBox>
    ));

    return (
        <Modal.Body>
            <div className="d-flex flex-column align-items-center justify-content-center gap-3">
                <SkeletonBox
                    style={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "50%",
                    }}
                />
            </div>
            <div className="d-flex flex-column gap-15 p-2">
                <HBox justifyContent="between" className="margin-bottom-10">
                    <SkeletonBox
                        style={{
                            width: "100%",
                            height: "30px",
                        }}
                    />
                </HBox>
                <HBox justifyContent="between" className="margin-bottom-10">
                    <SkeletonBox
                        style={{
                            width: "100%",
                            height: "30px",
                        }}
                    />
                </HBox>
                {skeletonRows}
            </div>
        </Modal.Body>
    );
}
